module.exports = __webpack_public_path__ + "img/kep4-5.73ea7cb2.jpg";